export default __webpack_public_path__ + "media/images/ongletwhite-right-admin-d671328b6c4a1fda16a9aa3f1dcb6f96.png";